import React, { useState, useEffect, useContext } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { Skeleton } from '@material-ui/lab';
import { CloudDownload, CloudUpload, Send } from '@material-ui/icons';
import Papa from "papaparse";
import { useSnackbar } from 'notistack';
import AppContext from '../../Services/AppContext';
import JString from '@easytech-international-sdn-bhd/jstring';
import API_Service, {axiosPutConfig} from '../../Services/API_Service';
import {
    req_bulk_import,
    req_check_outlet_exist
} from '../../Helper/Constants';


function BulkImport({ language }) {

    const [gState] = useContext(AppContext);
    const { enqueueSnackbar } = useSnackbar();

    const [data, setData] = useState([]);
    const [errors, setErrors] = useState([]);
    const [errors2, setErrors2] = useState([]);
    const [errorsMessage, setErrorsMessage] = useState([]);
    const [loading, setLoading] = useState(false);
    const [axiosPut, setAxiosPutConfig] = useState({});
    const [existingCodes, setExistingCodes] = useState(new Set());
    const [isPreChecking, setIsPreChecking] = useState(false);

    useEffect(() => {
		if (JString(gState.client).isValid()) {
			var axiosPut = axiosPutConfig(gState.client);
			setAxiosPutConfig(axiosPut);
		}
	}, [gState.client]);

    const downloadTemplate = () => {
        const csvHeaders = "Oulet Code,Oulet Name,Address,City,State,Zipcode,Region,Country,Latitude,Longitude,Area,Category,Chain,Type\n";
        const csvContent = csvHeaders;

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "outlet_template.csv";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const checkExistingCodes = (parsedData) => {
        if (parsedData.length <= 1) return;
        setIsPreChecking(true);
        const formdata = new FormData();
        parsedData.slice(1).forEach((row) => {
            formdata.append('cust_codes[]', row[0]);
        });
        formdata.append('company', gState.company || '');
        API_Service.post(req_check_outlet_exist, formdata, axiosPut)
            .then(({ data }) => {
                if (data.result === 1) {
                    setExistingCodes(new Set(data.extraData.existing_codes));
                } else {
                    enqueueSnackbar(data.message || language.bulk_import_check_error, { variant: 'error' });
                }
            })
            .catch(() => enqueueSnackbar(language.bulk_import_network_error, { variant: 'error' }))
            .finally(() => setIsPreChecking(false));
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];

        if (!file) {
            console.error("No file selected");
            return;
        }

        setExistingCodes(new Set());
        setLoading(true);
        setErrors2([]);
        setErrorsMessage([]);

        Papa.parse(file, {
            worker: true,
            complete: (result) => {
                const parsedData = result.data;
                const cleanedData = parsedData.filter(row => row.some(cell => cell.trim() !== ""));

                const expectedHeaders = [
                    "Oulet Code", "Oulet Name", "Address", "City", "State", "Zipcode",
                    "Region", "Country", "Latitude", "Longitude", "Area", "Category", "Chain", "Type"
                ];

                if (cleanedData.length === 0) {
                    setData([]);
                    setTimeout(() => setLoading(false), 500);
                    return;
                }

                const importedHeaders = cleanedData[0];
                const colIndices = expectedHeaders.map(h => importedHeaders.indexOf(h));

                const filteredData = cleanedData.map(row =>
                    colIndices.map(idx => (idx === -1 ? '' : (row[idx] !== undefined ? row[idx] : '')))
                );
                filteredData[0] = [...expectedHeaders];

                setData(filteredData);
                validateCSV(filteredData);
                checkExistingCodes(filteredData);
                setTimeout(() => setLoading(false), 500);
            },
            skipEmptyLines: true
        });
    };

    const validateCSV = (csvData) => {
        let newErrors = [];
        const optionalColumns = ["Latitude", "Longitude", "Type", "Chain", "Category", "City", "Region", "Country"];
        const headerRow = csvData[0];

        csvData.forEach((row, rowIndex) => {
            if (rowIndex === 0) return;
            
            row.forEach((cell, colIndex) => {
                const columnName = headerRow[colIndex];
                if (optionalColumns.includes(columnName)) {
                    return;
                }
                
                if (!cell.trim()) {
                    newErrors.push({ row: rowIndex + 1, col: colIndex + 1 });
                }
            });
        });

        setErrors(newErrors);       
    };

    const handleSubmit = async () => {

        if (!data.length) {
            alert("No data found. Please upload a valid CSV file.");
            return;
        }
    
        if (errors.length > 0) {
            alert("Please make sure all required fields are filled in.");
            return;
        }

        setLoading(true);
        let formData = new FormData();
        for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < data[i].length; j++) {
                formData.append(`data[${i}][${j}]`, data[i][j]);
            }
        }

        var created_by = gState.username;
        formData.append('created_by', created_by);
        formData.append('company',  gState.company ? gState.company : '');
        
        API_Service.post(req_bulk_import, formData, axiosPut).then(({data}) => {
            if (data.result === 0) {
                if (data.error_message && data.error_message.length > 0) {
                    setErrors2(data.error_message_position);
                    setErrorsMessage(data.error_message);
                }
                alert(data.message);
                setLoading(false);
            }else{
                const insertedCount = (data.extraData && data.extraData.inserted_count) || 0;
                const updatedCount  = (data.extraData && data.extraData.updated_count)  || 0;
                alert(`${data.message}\n${insertedCount} ${language.bulk_import_inserted}, ${updatedCount} ${language.bulk_import_updated}.`);
                setLoading(false);
                window.location.reload();
            }
        }).catch(() => {
            enqueueSnackbar(language.bulk_import_network_error, { variant: 'error' });
            setLoading(false);
        });
    };

    return (
        <Box display="flex" flexDirection="column" alignItems="center" width="100%">
            <Box display="flex" justifyContent="flex-end" alignItems="center" width="100%">
                <Button variant="contained" color="secondary" onClick={downloadTemplate}>
                    <CloudDownload style={{ marginRight: 8 }} />
                    {language.export_template}
                </Button>

                <Button
                    variant="contained"
                    component="label"
                    color="primary"
                    style={{ marginLeft: 8 }}
                >
                    <CloudUpload style={{ marginRight: 8 }} />
                    {language.import_csv}
                    <input type="file" accept=".csv" hidden onChange={handleFileUpload} />
                </Button>
            </Box>

            {loading && (
                <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="200px">
                    <Typography style={{ marginLeft: "10px" }}>Loading ...</Typography>
                </Box>
            )}

            {!loading && errors.length > 0 && (
                <Box color="red" alignSelf="flex-start" textAlign="left">
                    <strong> <span role="img" aria-label="warning">⚠️</span> Missing Data Detected - Please check the following rows and columns: <span role="img" aria-label="warning">⚠️</span> {language.error_detected}</strong>
                    <ul>
                        {errors.map((error, index) => (
                            <li key={index}>Row {error.row - 1}, Column ({data[0][error.col-1]}) is empty.</li>
                        ))}
                    </ul>
                </Box>
            )}

            {!loading && errorsMessage.length > 0 && (
                <Box color="orange" alignSelf="flex-start" textAlign="left">
                    <strong> <span role="img" aria-label="warning">⚠️</span> Import Data Failed - Please check the following rows and columns: <span role="img" aria-label="warning">⚠️</span> {language.error_detected}</strong>
                    <ul>
                        {errorsMessage.map((error, index) => (
                            <li key={index}>{error}</li>
                        ))}
                    </ul>
                </Box>
            )}

            {!loading && data.length > 0 && (
                <>
                    <table border="1" cellPadding="10" style={{ marginTop: "20px", borderCollapse: "collapse", width: "100%" }}>
                        <thead>
                            <tr>
                                <th style={{ backgroundColor: "#FEF200", color: "black" }}>NO</th>
                                {data[0].map((header, index) => (
                                    <th key={index} style={{ backgroundColor: "#FEF200", color: "black" }}>{header}</th>
                                ))}
                                <th style={{ backgroundColor: "#FEF200", color: "black" }}>{language.bulk_import_status}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.slice(1).map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    <td style={{fontWeight: "bold", textAlign: "center"}}>{rowIndex + 1}</td>
                                    {row.map((cell, colIndex) => {
                                        const isError = errors.some(error => error.row === rowIndex + 2 && error.col === colIndex + 1);
                                        const isError2 = errors2.some(error => error.row === rowIndex + 2 && error.col === colIndex + 1);
                                        return (
                                            <td key={colIndex} style={{
                                                border: isError ? "2px solid red" : isError2 ? "2px solid orange" : "1px solid #ddd",
                                                backgroundColor: isError ? "grey" : "transparent"
                                            }}>
                                                <input
                                                    type="text"
                                                    value={cell}
                                                    readOnly
                                                    // onChange={(event) => handleCellChange(event, rowIndex + 1, colIndex)}
                                                    style={{
                                                        width: "100%",
                                                        border: "none",
                                                        background: "transparent",
                                                        textAlign: "center",
                                                        outline: "none",
                                                        padding: "5px",
                                                        color: "white",
                                                    }}
                                                />
                                            </td>
                                        );
                                    })}
                                    <td style={{ border: '1px solid #ddd', textAlign: 'center', whiteSpace: 'nowrap' }}>
                                        {isPreChecking ? (
                                            <Skeleton variant="rect" animation="wave" width={60} height={20} style={{ margin: '0 auto', borderRadius: 4 }} />
                                        ) : existingCodes.has(row[0].toLowerCase()) ? (
                                            <span style={{ backgroundColor: '#FF9800', color: 'white', padding: '2px 8px', borderRadius: 4, fontSize: 12 }}>
                                                {language.bulk_import_update}
                                            </span>
                                        ) : (
                                            <span style={{ backgroundColor: '#4CAF50', color: 'white', padding: '2px 8px', borderRadius: 4, fontSize: 12 }}>
                                                {language.bulk_import_new}
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <Box display="flex" justifyContent="flex-end" width="100%" mt={2}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            style={{ marginBottom: 100 }}
                            disabled={errors.length > 0 || data.length === 1 || isPreChecking}
                        >
                            <Send style={{ marginRight: 8 }} />
                            {language.submit}
                        </Button>
                    </Box>

                </>
            )}
        </Box>
    );
}

export default BulkImport;
